import styled from "styled-components";

import { COLORS, ELEVATION } from "../../globals/designSystem";
import { mq } from "../../globals/utils";
import { transition } from "./CommonStyled";

export const StyledMainWrapper = styled.section`
  position: relative;
  .learnMainWrapper {
    display: grid;
    background-color: ${COLORS.grey_4};
    grid-template-columns: 1fr;
    ${transition}
    padding-left: 320px;
  }

  .mainSideBarToggle {
    position: absolute;
    top: 18px;
    left: 300px;
    z-index: 100000 !important;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: ${COLORS.white};
    box-shadow: ${ELEVATION.l_0};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    ${transition}
    svg {
      margin-right: 0 !important;
    }
    .navigation {
      position: absolute;
      left: 42px;
      top: 8px;
    }
  }
  .mainSideBarTogglePos {
    left: 16px;
  }
  .sideBarCollapse {
    padding-left: 0;
  }
  ${mq.between("lg", "xlg")} {
    .mainSideBarTogglePos {
      left: 24px;
    }
    .sideBarCollapse {
      padding-left: 140px;
    }
  }
  ${mq.above.xxxxl} {
    .learnMainWrapper {
      /* padding-left: 0; */
    }
  }
  ${mq.below.lg} {
    .learnMainWrapper {
      grid-template-columns: 1fr;
      padding-left: 0;
    }
    .mainSideBarToggle {
      display: none;
    }
  }
`;

export const StyledToggleSideNavWrapper = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: ${COLORS.sky_80};
  box-shadow: ${ELEVATION.l_2};
  position: fixed;
  bottom: 24px;
  right: 24px;
  display: none;
  z-index: 1000000 !important;
  ${transition}
  &:hover {
    background-color: ${COLORS.sky_90};
  }
  ${mq.below.lg} {
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: ${ELEVATION.l_2};
  }
`;

export const StyledSideBarWrapper = styled.div`
  .sidebarWrapper {
    width: 320px;
    background-color: ${COLORS.grey_4};
    padding: 16px;
    /* min-height: calc(100vh - 132px); */

    min-height: calc(100vh - 193px);
    height: calc(100vh - 193px);

    /* top: 132px; */

    top: ${props => (props?.isStripBannerActiveInView ? "190px" : "90px")};

    /* height: calc(100vh - 132px); */

    /* border-right: 1px solid ${COLORS.grey_20}; */
    border-bottom: 1px solid ${COLORS.grey_20};
    display: grid;
    position: fixed;
    left: 0;

    ${transition}
    .alignSelfStart {
      align-self: flex-start;
      /* max-height: calc(100vh - 520px);\ */

      max-height: ${props =>
        props?.isStripBannerActiveInView ? "calc(100vh - 380px)" : "calc(100vh - 340px)"};

      overflow: auto;
    }
    .removeExternalLinks {
      max-height: calc(100vh - 330px);
    }
    svg {
      margin-right: 8px;
      ${transition}
    }
    .rotateImg {
      transform: rotate(90deg);
    }
    .mainNavHeader {
      .tabListActive {
        background-color: ${COLORS.grey_10};
      }
      svg {
        margin-right: 8px;
      }
      a {
        display: flex;
        align-items: center;
        border-radius: 4px;
        padding: 8px 36px;
        padding-left: 8px;
        width: 100%;
        ${transition}
      }
      &:hover {
        background-color: ${COLORS.grey_10};
      }
    }
    .mainNavWrapper {
      padding-bottom: 12px;
      li {
        padding: 0 0;
        display: block;
        a {
          display: flex;
          align-items: center;
          padding: 8px 36px;
          border-radius: 4px;
          .circle {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: ${COLORS.grey_20};
            margin-right: 14px;
          }
          ${transition}
          &:hover {
            background-color: ${COLORS.grey_10};
          }
          svg {
            margin-right: 8px;
            ${transition}
          }
          .rotateImg {
            transform: rotate(90deg);
          }
        }
        .subNavWrapper {
          li {
            a {
              padding: 8px 36px;
              padding-left: 64px;
              .circle {
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background-color: ${COLORS.grey_20};
                margin-right: 8px;
              }
            }
          }
        }
      }
      .tabListActive {
        background-color: ${COLORS.grey_10};
      }
    }
  }
  .sidebarWrapperCollapse {
    background-color: transparent;
    width: 150px;
    border-right: 0;
    border-bottom: 0;
    min-height: auto;
    height: auto;
  }
  ${mq.below.lg} {
    .sidebarWrapper {
      z-index: 1000000 !important;
      transform: translateX(-325px);
      min-height: 100vh;
      height: 100vh;
      top: 0;
      box-shadow: ${ELEVATION.l_1};
      .alignSelfStart {
        max-height: calc(100vh - 380px);
      }
      .removeExternalLinks {
        max-height: calc(100vh - 284px);
      }
    }
  }
`;

export const StyledSideBarFooter = styled.div`
  border-top: 1px solid ${COLORS.grey_20};
  padding-top: 12px;
  align-self: flex-end;
  background-color: ${COLORS.grey_4};

  .sideBarNewsletterWrapper {
    min-height: 226px;
    max-height: 226px;
    overflow: auto;

    margin-top: 8px;
    border-top: 1px solid ${COLORS.grey_20};
    padding: 8px 8px 0;
    padding-top: 16px;
  }
`;

export const StyledLearnWrapper = styled.div`
  .learnAsideWrapper {
    max-width: 1176px;
    background: #fff;
    border-left: 1px solid ${COLORS.grey_20};
    margin: 0 auto;
    padding: 32px 64px;
    /* padding: 32px auto; */
    padding-bottom: 0;
    width: 100%;
    .footerImg {
      padding: 24px 0;
    }
    .removeBorBottom {
      border-bottom: 0 !important;
    }
  }
  ${mq.below.md} {
    padding: 32px;
    padding-bottom: 0;
    width: 100%;
  }
  .learnAsideWrapperPos {
    padding: 32px 32px;
  }
  ${mq.between("md", "lg")} {
    .learnAsideWrapper {
      padding: 32px;
    }
  }
  ${mq.below.md} {
    padding: 16px 0;
    padding-bottom: 0;
    .learnAsideWrapper {
      padding: 32px;
      padding-bottom: 0;
    }
  }

  @media (min-width: 1500px) {
    background: #fff;
    justify-content: center;
    .learnAsideWrapper {
      padding-left: 17%;
      margin: 0 auto 0 0;
    }
  }
`;
